import { useEffect } from "react";

/**
 * FS-161(a) — aviso NATIVO de saída enquanto há trabalho não enviado.
 *
 * Cobre o que o React Router não vê: F5, fechar a aba, digitar outra URL,
 * voltar no histórico para fora do app. O navegador mostra o diálogo dele
 * ("Sair do site?"), que não é customizável — texto próprio é ignorado por
 * todos os navegadores modernos.
 *
 * `enabled` DEVE ser o "formulário sujo": listener sempre ligado transformaria
 * cada F5 numa pergunta, e um aviso que aparece sempre é um aviso que ninguém
 * lê. Passar a `false` desarma na hora — é assim que o SUCESSO do envio sai da
 * tela sem perguntar nada (o dado já está no servidor).
 *
 * A saída por botão do PRÓPRIO wizard não passa por aqui: navegação SPA não
 * dispara `beforeunload`. Esses botões pedem confirmação por AlertDialog na
 * tela; o menu lateral e o logout ficam FORA desta leva por decisão do owner
 * (P6) — cobri-los exigiria migrar o router, e o rascunho em sessionStorage
 * (FS-161b) já evita a perda nesses caminhos.
 */
export default function useUnsavedChangesWarning(enabled) {
  useEffect(() => {
    if (!enabled) return undefined;
    const handler = (e) => {
      // As DUAS formas: `preventDefault()` é a especificada; `returnValue`
      // ainda é o que alguns navegadores exigem para exibir o diálogo.
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [enabled]);
}
